(function () {
    'use strict';

    angular
        .module('oddQuestionnaireTemplateModule')
        .directive('oddConditionableSection', directive);

    directive.$inject = ['oddQuestionnaireTemplateService', 'modalService'];

    function directive(oddQuestionnaireTemplateService, modalService) {
        return {
            restrict: 'E',
            scope: {
                section: '=',
                isDisabled: '=',
                onChoiceSelected: '&',
                onConditionRemoved: '&',
                required: '&'
            },
            require: ['^form'],
            templateUrl: require('./oddConditionableSection.tpl.html'),
            link: function ($scope, $element, $attrs, $ctrl) {
                $scope.form = $ctrl[0];
                $scope.validate();
            },
            controller: ['$rootScope', '$scope', function ($rootScope, $scope) {
                $scope.required = $scope.required();
                $scope.style = {};

                $scope.add = add;
                $scope.remove = remove;
                $scope.validate = validate;

                function validate() {
                    if ($scope.required) {
                        $scope.form.$setValidity('ConditionalODDQuestion', !!$scope.ConditionalODDQuestionID);
                    }
                }

                function add() {
                    oddQuestionnaireTemplateService
                        .getConditionableQuestionsForSection(
                            $scope.section.ODDBusinessUnitID,
                            $scope.section.ODDQuestionnaireID,
                            $scope.section.ODDSectionID)

                        .then(function (conditionableSections) {
                            var modal = modalService.displayTemplateModal(
                                'Select a Section',
                                require('./oddConditionableSection.modal.tpl.html'),
                                {
                                    ctxtCtrl: {
                                        selectedSection: null,
                                        selectedQuestion: null,
                                        availableSections: conditionableSections.ConditionableODDSections,
                                        availableQuestion: null
                                    },
                                    classes: 'modal-lg',
                                    onSectionSelection: function (ctxtCtrl, section) {
                                        modal.$scope.title = 'Select a Question';
                                        ctxtCtrl.selectedSection = section;
                                    },
                                    onQuestionSelection: function(ctxtCtrl, question) {
                                        modal.$scope.title = 'Select a Choice';
                                        ctxtCtrl.selectedQuestion = question;
                                    },
                                    onChoiceSelection: function(ctxtCtrl, choice) {
                                        $scope.onChoiceSelected({
                                            question: ctxtCtrl.selectedQuestion,
                                            choice: choice
                                        });
                                        modal.hide();
                                    }
                                },
                                false
                            );
                    });
                }

                function remove() {
                    $scope.onConditionRemoved();
                }
            }]
        }
    }
})();
